import { Box, MenuItem, Typography } from '@mui/material'

// others
import { UserRole } from '../../../generated'

// components
import CustomMultiSelectChip from '../common/CustomMultiSelectChip'
import useUsers from '../../hooks/useUsers'
import { UserState } from './userReducer'
import { useCallback } from 'react'

const SelectDelegates = ({ userState }: { userState?: UserState }) => {
  const {
    allUsers: usersData,
    setAllUsers: setUsersData,
    setUserPage,
    setUserSearchTerm,
    getUserFromCache
  } = useUsers({
    customUserRoles: [UserRole.Paralegal]
  })

  const { currentUser } = userState || {}
  const { paralegals } = currentUser || {}

  const getLabel = (userId: string) => {
    let user = usersData?.find(u => u.id === userId)

    if (!user) {
      user = getUserFromCache(userId)
    }
    if (user) {
      const { email, firstName, lastName } = user
      return `${firstName} ${lastName}${email ? ' ' + email : ''}`
    }
    return userId || ''
  }

  const getChipLabel = (userId: string) => {
    let user = usersData?.find(u => u.id === userId)

    if (!user) {
      user = getUserFromCache(userId)
    }

    if (user) {
      const { email, firstName, lastName } = user
      return (
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="body1" fontSize={12}>
            {`${firstName} ${lastName}`}
          </Typography>
          <Typography variant="subtitle1" fontSize={10}>
            {email}
          </Typography>
        </Box>
      )
    }

    paralegals?.map(paralegal => {
      if (paralegal?.id === userId) {
        setUsersData(prev => [...prev, paralegal])

        const { email, firstName, lastName } = paralegal
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body1" fontSize={12}>
              {`${firstName} ${lastName}`}
            </Typography>
            <Typography variant="subtitle1" fontSize={10}>
              {email}
            </Typography>
          </Box>
        )
      } else
        return (
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="body1" fontSize={12}>
              {userId}
            </Typography>
          </Box>
        )
    })
  }

  const handleSearchTermChange = useCallback(
    (searchTerm: string) => {
      setUserSearchTerm(searchTerm)
    },
    [setUserSearchTerm]
  )

  return (
    <CustomMultiSelectChip
      name="delegateIds"
      label="Delegates"
      setPage={setUserPage}
      setSearchTerm={handleSearchTermChange}
      chipLabel={getChipLabel}
      getLabel={getLabel}
      children={usersData?.map((item, index) => {
        const { id, email, firstName, lastName, roles } = item ?? {}
        const { role } = roles?.[0] ?? {}
        return (
          role === UserRole.Paralegal && (
            <MenuItem value={id} key={`${email}-${index}`}>
              <Box display={'flex'} alignItems={'center'} gap={1}>
                <Typography variant="body1">{`${firstName} ${lastName}`}</Typography>
                <Typography variant="subtitle1">({email})</Typography>
              </Box>
            </MenuItem>
          )
        )
      })}
    />
  )
}

export default SelectDelegates
